import type { StateCreator } from 'zustand';

export interface ConfigSlice {
	// Static configuration (set once at initialization)
	formId: number;
	bookingFieldId: number;
	serviceFieldId: number | null; // For monitoring service field changes
	resourceFieldIds: number[];
	slotMode: 'aligned' | 'flexible';
	interval: number;
	showEndTimes: boolean;
	showTimezoneIndicator: boolean;
	timezoneMessage: string | null;
	startingMonthMode: 'first_availability_window' | 'current' | 'specific';
	startingMonth: number | null;
	startingYear: number | null;

	// Actions
	setConfig: (config: {
		formId: number;
		bookingFieldId: number;
		serviceFieldId: number | null;
		resourceFieldIds: number[];
		slotMode: 'aligned' | 'flexible';
		interval: number;
		showEndTimes: boolean;
		showTimezoneIndicator: boolean;
		timezoneMessage: string | null;
		startingMonthMode: 'first_availability_window' | 'current' | 'specific';
		startingMonth: number | null;
		startingYear: number | null;
	}) => void;
}

export const createConfigSlice: StateCreator<ConfigSlice> = (set) => ({
	formId: 0,
	bookingFieldId: 0,
	serviceFieldId: null,
	resourceFieldIds: [],
	slotMode: 'aligned',
	interval: 0,
	showEndTimes: true,
	showTimezoneIndicator: true,
	timezoneMessage: null,
	startingMonthMode: 'first_availability_window',
	startingMonth: null,
	startingYear: null,

	setConfig: (config) => set(config),
});
